import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { generateUUID } from '../lib/utils';
import { ComposerInput } from './ComposerInput';
/**
 * PromptComposer - Wrapper around ComposerInput for creating new chats
 *
 * This component handles the chat creation logic:
 * 1. Generates a new chat ID
 * 2. Stores initial prompt in sessionStorage
 * 3. Navigates to the chat page (ChatView will auto-send on mount)
 */ export function PromptComposer(props) {
    const navigate = useNavigate();
    const handleStartChat = async (data)=>{
        const uuid = generateUUID();
        // Prefix with 'shanks-' so the ID aligns with history
        const chatId = `shanks-${uuid}`;
        // Store initial prompt + attachments in sessionStorage
        // The ChatView will read this and send the message on mount
        try {
            sessionStorage.setItem(`init::${chatId}`, JSON.stringify({
                prompt: data.prompt,
                attachments: data.attachments
            }));
        } catch (error) {
            // SessionStorage failed - fallback to direct navigation
            console.warn('Failed to store initial prompt in sessionStorage', error);
        }
        navigate(`/assistant/${chatId}`);
    };
    return /*#__PURE__*/ _jsx(ComposerInput, {
        ...props,
        onSubmit: handleStartChat
    });
}
